/**
 * Resolve an ObjectRecord's display label.
 *
 * `display` (derived from the ObjectType's configured display fields, e.g.
 * Name) is the user-facing identity of a record — `code` is a system-
 * generated internal identifier and should only be shown as a fallback when
 * no display fields are configured.
 */
export function formatReferenceLabel(record: {
  code: string;
  display?: string;
}): string {
  return record.display ?? record.code;
}
